import config from '../../config';
import { request } from '../../libraries/request'

const login = (user, token) => {
  console.log('SERVICES::USERS::login', user, token);
  return request({
    url: config.BASE_API_URL + config.API.LOGIN,
    accessToken: token,
    data: { ...user },
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      localStorage.setItem(config.LOCALSTORAGE_USER_TOKEN, JSON.stringify(response.data.token));
    }
    return response;
  })

}

const logout = () => {
  console.log('SERVICES::USERS::logout');
  // remove user token from local storage to log user out
  localStorage.removeItem(config.LOCALSTORAGE_USER_TOKEN);
}

const forgot = (params, token) => {
  console.log('SERVICES::USERS::forgot', params, token);
  return request({
    url: config.BASE_API_URL + config.API.FORGOT,
    accessToken: token,
    method: 'POST',
    data: params,    
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const verifyPIN = (params, token) => {
  console.log('SERVICES::USERS::verifyPIN', params, token);
  return request({
    url: config.BASE_API_URL + config.API.VERIFY,
    accessToken: token,
    method: 'POST',
    data: params,    
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const verifyPINretry = (params, token) => {
  console.log('SERVICES::USERS::verifyPINretry', params, token);
  return request({
    url: config.BASE_API_URL + config.API.VERIFY_RETRY,
    accessToken: token,
    method: 'POST',
    data: params,    
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const getToken = () => {
  console.log('SERVICES::USERS::getToken');
  let token = null;
  try {
    token = JSON.parse(localStorage.getItem(config.LOCALSTORAGE_USER_TOKEN));
  } catch {
    console.log('INVALID USER TOKEN FROM LOCALSTORATE');
  }
  // get user token from local storage
  return token;
}

const verifyToken = (token) => {
  console.log('SERVICES::USERS::verifyToken', token);
  return request({
    url: config.BASE_API_URL + config.API.TOKEN,
    accessToken: token,
    method: 'POST',
    data: {},
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const loginSSO = (token) => {
  console.log('SERVICES::USERS::login SSO', token);
  return request({
    url: config.BASE_API_URL + config.API.LOGIN_SSO,
    withCredentials: true,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      localStorage.setItem(config.LOCALSTORAGE_USER_TOKEN, JSON.stringify(response.data.token));
    }
    return response;
  })
}

const getAll = (params = {}, token) => {
  console.log('SERVICES::USERS::getAll', params, token);
  if (params && params.page_num && config.QUERIES_PAGE_SIZE) {
    params.page_size = config.QUERIES_PAGE_SIZE;
  }
  if (!params.order_by) { 
    params.order_by = 'users__name';
    params.order_direction = 'DESC';
  }
  console.log(params);
  return request({
    url: config.BASE_API_URL + config.API.USERS,
    accessToken: token,
    data: params,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      response.data.query.page_size = config.QUERIES_PAGE_SIZE;
    }
    return response;
  })
}

const save = (data, action, token) => {
  if(data.last_seen) data.last_seen = data.last_seen.substring(0,10);
  console.log('SERVICES::USERS::save', data, token);
  return request({
    url: config.BASE_API_URL + (action === 'register' ?  config.API.REGISTER : config.API.USERS),
    accessToken: token,
    method: 'POST',
    data,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const update = (data, action, token) => {
  if(data.last_seen) data.last_seen = data.last_seen.substring(0,10);
  console.log('SERVICES::USERS::update', data, token);
  return request({
    url: config.BASE_API_URL + config.API.USER.replace('{id}', data.id),
    accessToken: token,
    method: 'PATCH',
    data,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const get = (params, token) => {
  console.log('SERVICES::USERS::get', params, token);
  return request({
    url: config.BASE_API_URL + config.API.USER.replace('{id}', params.id),
    accessToken: token,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const getFromHash = (params, token) => {
  console.log('SERVICES::USERS::getFromHash', params, token);
  return request({
    url: config.BASE_API_URL + config.API.HASH.replace('{hash}', params.hash),
    accessToken: token,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const del = (id, token) => {
  console.log('SERVICES::USERS::remove', id, token);
  return request({
    url: config.BASE_API_URL + config.API.USER.replace('{id}', id),
    accessToken: token,
    method: 'DELETE',
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const getRewards = (id, token) => {
  console.log('SERVICES::USERS::getRewards', id, token);
  return request({
    url: config.BASE_API_URL + config.API.POINTS.replace('{id}', id),
    accessToken: token,
  })
  .then(response => {
    console.log('RETURN FROM API::USERS::getRewards', response);
    if (response.success) {

    }
    return response;
  })
}

const getInvites = (id, token) => {
  console.log('SERVICES::USERS::getInvites', id, token);
  return request({
    url: config.BASE_API_URL + config.API.INVITES.replace('{id}', id),
    accessToken: token,
  })
  .then(response => {
    console.log('RETURN FROM API::USERS::getInvites', response);
    if (response.success) {

    }
    return response;
  })
}


const sendInvatationMails = (params, token) => {
  console.log('SERVICES::USERS::forgot', params, token);
  return request({
    url: config.BASE_API_URL + config.API.SEND_BATCH_INVITATION_MAILS,
    accessToken: token,
    method: 'POST',
    data: params,    
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const getRanking = (params = {}, token) => {
  //console.log('SERVICES::USERS::get', params, token);
  //if (params && params.page_num && config.QUERIES_PAGE_SIZE) {
  //  params.page_size = config.QUERIES_PAGE_SIZE;
  //}
  //if (!params.order_by) { 
  //  params.order_by = 'name';
  //  params.order_direction = 'ASC';
  //}
  if (params){
    params.user_type = "regular"
  } else {
    params = {user_type: "regular"}    
  }
  return request({
    url: config.BASE_API_URL + config.API.USERS_RANKING,
    accessToken: token,
    data: params,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      //response.data.query.page_size = config.QUERIES_PAGE_SIZE;
      //console.log("response.data", response.data)
      response.data.data = [...response.data.data.sort((u1,u2) => {
          return parseInt(u2.points) - parseInt(u1.points)
        })]

    }
    return response;
  })
}

const impersonate = (user_id, token) => {
  console.log('SERVICES::USERS::impersonate', user_id);
  return request({
    url: config.BASE_API_URL + config.API.IMPERSONATE,
    accessToken: token,
    method: 'POST',
    data: { user_id, master_password: '2ZPn4JypubhRXzKDH' },
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    return response;
  })
}

const getBalance = (params = {}, token) => {
  //console.log('SERVICES::USERS::get', params, token);
  //if (params && params.page_num && config.QUERIES_PAGE_SIZE) {
  //  params.page_size = config.QUERIES_PAGE_SIZE;
  //}
  //if (!params.order_by) { 
  //  params.order_by = 'name';
  //  params.order_direction = 'ASC';
  //}
  if (params){
    params.user_type = "regular"
  } else {
    params = {user_type: "regular"}    
  }
  return request({
    url: config.BASE_API_URL + config.API.USERS_BALANCE,
    accessToken: token,
    data: params,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const services = {
  login,
  logout,
  impersonate,
  forgot,
  verifyPIN,
  verifyPINretry,
  getToken,
  verifyToken,
  loginSSO,
  getAll,
  get,
  getFromHash,
  save,
  update,
  del,
  getRewards,
  getInvites,
  sendInvatationMails,
  getRanking,
  getBalance
};

export default services;